import { Navigate, useLocation } from 'react-router-dom';
import { ReactNode } from 'react';
import { useAuth } from '../contexts/AuthContext';

interface Props {
  children: ReactNode;
}

export default function PrivateRoute({
  children,
}: Props) {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    const callbackUrl = encodeURIComponent(
      location.pathname + location.search + location.hash
    );

    return (
      <Navigate
        to={`/login?callbackUrl=${callbackUrl}`}
        replace
      />
    );
  }

  return <>{children}</>;
}